import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import api from "../lib/api";
import { Reveal } from "../components/Reveal";
import { Footer } from "../components/Footer";

export default function Gallery() {
  const { slug } = useParams();
  const [prints, setPrints] = useState([]);
  const [cats, setCats] = useState([]);
  const current = cats.find((c) => c.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/categories").then((r) => setCats(r.data));
  }, []);
  useEffect(() => {
    api.get("/prints", { params: { category: slug } }).then((r) => setPrints(r.data));
  }, [slug]);

  return (
    <div className="pt-[7.25rem]">
      <Helmet>
        <title>{current ? `${current.name} Prints` : "Prints"} | Prairie Prints MT</title>
        <meta name="description" content={current?.blurb ? `${current.blurb} Archival fine art prints from Northeast Montana — free shipping.` : "Fine art photography prints from Northeast Montana."} />
        <link rel="canonical" href={`https://montana-landscapes.emergent.host/gallery/${slug}`} />
      </Helmet>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <span className="label text-brick">Collection</span>
        <h1 className="font-serif text-6xl md:text-7xl tracking-tight mt-3">{current?.name || "Prints"}</h1>
        <p className="text-stone max-w-xl mt-4 text-lg leading-relaxed">{current?.blurb}</p>

        <div className="flex gap-3 flex-wrap mt-10">
          {cats.map((c) => (
            <Link key={c.slug} to={`/gallery/${c.slug}`} data-testid={`filter-${c.slug}`}
              className={`label px-5 py-2.5 border transition-colors duration-300 ${c.slug === slug ? "bg-ink text-paper border-ink" : "border-line text-ink hover:border-ink"}`}>
              {c.name}
            </Link>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 mt-16">
          {prints.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <Link to={`/print/${p.id}`} data-testid={`print-card-${p.id}`} className="group block">
                <div className="overflow-hidden border border-line bg-paper-2 aspect-[4/5]">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
                </div>
                <div className="flex items-baseline justify-between mt-4">
                  <h3 className="font-serif text-2xl tracking-tight">{p.title}</h3>
                  <span className="label text-stone">${p.sizes[0].price.toFixed(0)}+</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
